import { WhatsAppState } from "./types";

const state: WhatsAppState = {
  templates: [],
  application_settings: {},
  profile_settings: {},
  server_status: false,
  groups: [],
  servers: [],
  flows: {
    data: [],
    total: 0,
  },
  selectedFlow: {
    preview: {},
    json: {},
  },
  download: {
    isDownloading: false,
    progress: 0,
    processed: 0,
    total: 0,
    generatedPassword: "",
  },
};

export default state;
